module.exports = __webpack_public_path__ + "static/media/Diseño.bf086d3b.png";